import { render } from "./listForClient.vue?vue&type=template&id=54d30c0e&ts=true"
import script from "./listForClient.vue?vue&type=script&lang=ts&config=true"
export * from "./listForClient.vue?vue&type=script&lang=ts&config=true"

import "./listForClient.vue?vue&type=style&index=0&id=54d30c0e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__